import { useEffect } from 'react';

const BASE_TITLE = 'Dr. Leonardo Pacheco - Naturopata / Homeopata';

export const usePageTitle = (pageTitle) => {
  useEffect(() => {
    document.title = pageTitle ? `${BASE_TITLE} | ${pageTitle}` : BASE_TITLE;
    return () => { document.title = BASE_TITLE; };
  }, [pageTitle]);
};
